module.exports = __webpack_public_path__ + "static/media/15_4.9005178e.png";